const actions = {
    LOCATION_CREATE_REQUEST: 'LOCATION_CREATE_REQUEST',
    LOCATION_CREATE_SUCCESS: 'LOCATION_CREATE_SUCCESS',
    LOCATION_CREATE_ERROR: 'LOCATION_CREATE_ERROR',

    LOCATION_IMPORT_REQUEST: 'LOCATION_IMPORT_REQUEST',
    LOCATION_IMPORT_SUCCESS: 'LOCATION_IMPORT_SUCCESS',
    LOCATION_IMPORT_ERROR: 'LOCATION_IMPORT_ERROR',

    LOCATION_READ_REQUEST: 'LOCATION_READ_REQUEST',
    LOCATION_READ_SUCCESS: 'LOCATION_READ_SUCCESS',
    LOCATION_READ_ERROR: 'LOCATION_READ_ERROR',

    LOCATION_READ_ALL_REQUEST: 'LOCATION_READ_ALL_REQUEST',
    LOCATION_READ_ALL_SUCCESS: 'LOCATION_READ_ALL_SUCCESS',
    LOCATION_READ_ALL_ERROR: 'LOCATION_READ_ALL_ERROR',

    LOCATION_UPDATE_REQUEST: 'LOCATION_UPDATE_REQUEST',
    LOCATION_UPDATE_SUCCESS: 'LOCATION_UPDATE_SUCCESS',
    LOCATION_UPDATE_ERROR: 'LOCATION_UPDATE_ERROR',

    LOCATION_ARCHIVE_REQUEST: 'LOCATION_ARCHIVE_REQUEST',
    LOCATION_ARCHIVE_SUCCESS: 'LOCATION_ARCHIVE_SUCCESS',
    LOCATION_ARCHIVE_ERROR: 'LOCATION_ARCHIVE_ERROR',

    LOCATION_DELETE_REQUEST: 'LOCATION_DELETE_REQUEST',
    LOCATION_DELETE_SUCCESS: 'LOCATION_DELETE_SUCCESS',
    LOCATION_DELETE_ERROR: 'LOCATION_DELETE_ERROR',

    LOCATION_RESET_STATE: 'LOCATION_RESET_STATE',
    LOCATION_CHANGE: 'LOCATION_CHANGE',

    createLocation: request => ({
        type: actions.LOCATION_CREATE_REQUEST,
        request,
    }),
    importLocation: request => ({
        type: actions.LOCATION_IMPORT_REQUEST,
        request,
    }),
    readLocation: id => ({
        type: actions.LOCATION_READ_REQUEST,
        id,
    }),
    readAllLocation: request => ({
        type: actions.LOCATION_READ_ALL_REQUEST,
        request,
    }),
    updateLocation: (id, request) => ({
        type: actions.LOCATION_UPDATE_REQUEST,
        id,
        request,
    }),
    archiveLocation: (id, request) => ({
        type: actions.LOCATION_ARCHIVE_REQUEST,
        id,
        request,
    }),
    deleteLocation: id => ({
        type: actions.LOCATION_DELETE_REQUEST,
        id,
    }),
    resetLocation: id => ({
        type: actions.LOCATION_RESET_STATE,
        id,
    }),

    changeLocation: (request, reset = false) => ({
        type: actions.LOCATION_CHANGE,
        request,
        reset,
    }),
};
export default actions;
